import { render, staticRenderFns } from "./BooleanSetting.vue?vue&type=template&id=3cfda50e"
import script from "./BooleanSetting.vue?vue&type=script&lang=js"
export * from "./BooleanSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports